import React from 'react';

/** A form field in a modal or panel. The toolbar search is `.st-input` instead. */
export const Field = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...rest }, ref) => <input ref={ref} className={`st-field${className ? ` ${className}` : ''}`} {...rest} />,
);
Field.displayName = 'Field';

export const TextArea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...rest }, ref) => (
    <textarea ref={ref} className={`st-field${className ? ` ${className}` : ''}`} {...rest} />
  ),
);
TextArea.displayName = 'TextArea';

/** A field's name, or the key in a key/value list. */
export const Label: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, ...rest }) => (
  <span className={`st-label${className ? ` ${className}` : ''}`} {...rest} />
);

/** The small uppercase heading over a group of rows. */
export const Caps: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div className={`st-caps${className ? ` ${className}` : ''}`} {...rest} />
);
